import React from 'react';
import PropTypes from 'prop-types';

function IconDuplicate({ color = '#88898B', size = 16, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.5 11H2.75C2.55109 11 2.36032 10.921 2.21967 10.7803C2.07902 10.6397 2 10.4489 2 10.25V2.75002C2 2.5511 2.07902 2.36034 2.21967 2.21969C2.36032 2.07903 2.55109 2.00002 2.75 2.00002H10.25C10.4489 2.00002 10.6397 2.07903 10.7803 2.21969C10.921 2.36034 11 2.5511 11 2.75002V3.50002M5.75 14H13.25C13.4489 14 13.6397 13.921 13.7803 13.7803C13.921 13.6397 14 13.4489 14 13.25V5.75002C14 5.5511 13.921 5.36034 13.7803 5.21969C13.6397 5.07903 13.4489 5.00002 13.25 5.00002H5.75C5.55109 5.00002 5.36032 5.07903 5.21967 5.21969C5.07902 5.36034 5 5.5511 5 5.75002V13.25C5 13.4489 5.07902 13.6397 5.21967 13.7803C5.36032 13.921 5.55109 14 5.75 14Z" stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
    </svg>
  )
}

IconDuplicate.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string
}

export default IconDuplicate;
